import { Component } from '@angular/core';
import { ArcliveViewComponent } from "../shared/arclive-view/arclive-view.component";
import { CesiumService } from '../../core/services/cesium.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ArcliveViewComponent],
  providers: [CesiumService],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

}
